document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.nfb-modal');

  Array.from(modals).forEach( (modal) => {
    const triggerID = modal.getAttribute('data-modal-trigger');

    const trigger = document.getElementById( triggerID );

    trigger.addEventListener('click', () => {
        modal.classList.add('open');
    })

    const closeBtn = modal.querySelector('.nfb-modal__close');
    closeBtn.addEventListener('click', () => {
        modal.classList.remove('open');
    })

    const overlay = modal.querySelector('.nfb-modal__overlay');
    overlay.addEventListener('click', () => {
        modal.classList.remove('open');
    })
  })
})
